import type { QueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { SessionContext } from '@/lib/types';

export const companiesKey = ['companies'] as const;
export const companyChangeKey = 'cop.company.changed';

/** A fresh document discards local form state, requests, and every workspace cache. */
export async function switchCompany(qc: QueryClient, company: SessionContext, userId: string) {
  if (company.kind !== 'staff') throw new Error('Choose an organisation workspace.');
  if (qc.isMutating()) throw new Error('Wait for changes to finish saving before switching companies.');
  await qc.cancelQueries();
  await api.post('/companies/switch', { tenantId: company.tenantId, membershipId: company.membershipId });
  await reloadCompany(qc, userId);
}

export async function reloadCompany(qc: QueryClient, userId: string) {
  await qc.cancelQueries();
  qc.clear();
  try { localStorage.setItem(companyChangeKey, JSON.stringify({ userId, at: Date.now() })); } catch { /* Request guard also protects tabs when storage is unavailable. */ }
  window.location.replace('/dashboard');
}
